module.exports = __webpack_public_path__ + "img/icon-products-magento-62.9f6caa1e.svg";